import { addMinutes, isValid } from 'date-fns';
import { getTimezoneOffset } from 'date-fns-tz';
import { isNotEmpty } from '../utils/isEmpty';
import type { Platform } from 'componentregistry/platform/Platform';
import { IoDatasourceAttributes } from '@cloudio-saas/datasource-types';

export const allDateFormats = [
  'MM/dd/yyyy',
  'MM-dd-yyyy',
  'dd-MM-yyyy',
  'dd.MM.yyyy',
  'dd/MM/yyyy',
  'yyyy-MM-dd',
  'yyyy.MM.dd',
  'yyyy/MM/dd',
];

const timeFormats = [
  'h:mm a',
  'H:mm',
  'HH:mm',
  'HH:mm:ss',
  'hh:mm a',
  'hh:mm:ss a',
];

const timeZones = [
  'Africa/Abidjan',
  'Africa/Accra',
  'Africa/Algiers',
  'Africa/Bissau',
  'Africa/Cairo',
  'Africa/Casablanca',
  'Africa/Ceuta',
  'Africa/El_Aaiun',
  'Africa/Johannesburg',
  'Africa/Juba',
  'Africa/Khartoum',
  'Africa/Lagos',
  'Africa/Maputo',
  'Africa/Monrovia',
  'Africa/Nairobi',
  'Africa/Ndjamena',
  'Africa/Sao_Tome',
  'Africa/Tripoli',
  'Africa/Tunis',
  'Africa/Windhoek',
  'America/Adak',
  'America/Anchorage',
  'America/Araguaina',
  'America/Argentina/Buenos_Aires',
  'America/Argentina/Catamarca',
  'America/Argentina/Cordoba',
  'America/Argentina/Jujuy',
  'America/Argentina/La_Rioja',
  'America/Argentina/Mendoza',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Salta',
  'America/Argentina/San_Juan',
  'America/Argentina/San_Luis',
  'America/Argentina/Tucuman',
  'America/Argentina/Ushuaia',
  'America/Asuncion',
  'America/Atikokan',
  'America/Bahia',
  'America/Bahia_Banderas',
  'America/Barbados',
  'America/Belem',
  'America/Belize',
  'America/Blanc-Sablon',
  'America/Boa_Vista',
  'America/Bogota',
  'America/Boise',
  'America/Cambridge_Bay',
  'America/Campo_Grande',
  'America/Cancun',
  'America/Caracas',
  'America/Cayenne',
  'America/Chicago',
  'America/Chihuahua',
  'America/Costa_Rica',
  'America/Creston',
  'America/Cuiaba',
  'America/Curacao',
  'America/Danmarkshavn',
  'America/Dawson',
  'America/Dawson_Creek',
  'America/Denver',
  'America/Detroit',
  'America/Edmonton',
  'America/Eirunepe',
  'America/El_Salvador',
  'America/Fort_Nelson',
  'America/Fortaleza',
  'America/Glace_Bay',
  'America/Godthab',
  'America/Goose_Bay',
  'America/Grand_Turk',
  'America/Guatemala',
  'America/Guayaquil',
  'America/Guyana',
  'America/Halifax',
  'America/Havana',
  'America/Hermosillo',
  'America/Indiana/Indianapolis',
  'America/Indiana/Knox',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Tell_City',
  'America/Indiana/Vevay',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Inuvik',
  'America/Iqaluit',
  'America/Jamaica',
  'America/Juneau',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/La_Paz',
  'America/Lima',
  'America/Los_Angeles',
  'America/Maceio',
  'America/Managua',
  'America/Manaus',
  'America/Martinique',
  'America/Matamoros',
  'America/Mazatlan',
  'America/Menominee',
  'America/Merida',
  'America/Metlakatla',
  'America/Mexico_City',
  'America/Miquelon',
  'America/Moncton',
  'America/Monterrey',
  'America/Montevideo',
  'America/Nassau',
  'America/New_York',
  'America/Nipigon',
  'America/Nome',
  'America/Noronha',
  'America/North_Dakota/Beulah',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/Ojinaga',
  'America/Panama',
  'America/Pangnirtung',
  'America/Paramaribo',
  'America/Phoenix',
  'America/Port-au-Prince',
  'America/Port_of_Spain',
  'America/Porto_Velho',
  'America/Puerto_Rico',
  'America/Punta_Arenas',
  'America/Rainy_River',
  'America/Rankin_Inlet',
  'America/Recife',
  'America/Regina',
  'America/Resolute',
  'America/Rio_Branco',
  'America/Santarem',
  'America/Santiago',
  'America/Santo_Domingo',
  'America/Sao_Paulo',
  'America/Scoresbysund',
  'America/Sitka',
  'America/St_Johns',
  'America/Swift_Current',
  'America/Tegucigalpa',
  'America/Thule',
  'America/Thunder_Bay',
  'America/Tijuana',
  'America/Toronto',
  'America/Vancouver',
  'America/Whitehorse',
  'America/Winnipeg',
  'America/Yakutat',
  'America/Yellowknife',
  'Antarctica/Casey',
  'Antarctica/Davis',
  'Antarctica/DumontDUrville',
  'Antarctica/Macquarie',
  'Antarctica/Mawson',
  'Antarctica/Palmer',
  'Antarctica/Rothera',
  'Antarctica/Syowa',
  'Antarctica/Troll',
  'Antarctica/Vostok',
  'Asia/Almaty',
  'Asia/Amman',
  'Asia/Anadyr',
  'Asia/Aqtau',
  'Asia/Aqtobe',
  'Asia/Ashgabat',
  'Asia/Atyrau',
  'Asia/Baghdad',
  'Asia/Baku',
  'Asia/Bangkok',
  'Asia/Barnaul',
  'Asia/Beirut',
  'Asia/Bishkek',
  'Asia/Brunei',
  'Asia/Calcutta',
  'Asia/Chita',
  'Asia/Choibalsan',
  'Asia/Colombo',
  'Asia/Damascus',
  'Asia/Dhaka',
  'Asia/Dili',
  'Asia/Dubai',
  'Asia/Dushanbe',
  'Asia/Famagusta',
  'Asia/Gaza',
  'Asia/Hebron',
  'Asia/Ho_Chi_Minh',
  'Asia/Hong_Kong',
  'Asia/Hovd',
  'Asia/Irkutsk',
  'Asia/Jakarta',
  'Asia/Jayapura',
  'Asia/Jerusalem',
  'Asia/Kabul',
  'Asia/Kamchatka',
  'Asia/Karachi',
  'Asia/Kathmandu',
  'Asia/Khandyga',
  'Asia/Krasnoyarsk',
  'Asia/Kuala_Lumpur',
  'Asia/Kuching',
  'Asia/Macau',
  'Asia/Magadan',
  'Asia/Makassar',
  'Asia/Manila',
  'Asia/Nicosia',
  'Asia/Novokuznetsk',
  'Asia/Novosibirsk',
  'Asia/Omsk',
  'Asia/Oral',
  'Asia/Pontianak',
  'Asia/Pyongyang',
  'Asia/Qatar',
  'Asia/Qostanay',
  'Asia/Qyzylorda',
  'Asia/Riyadh',
  'Asia/Sakhalin',
  'Asia/Samarkand',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Srednekolymsk',
  'Asia/Taipei',
  'Asia/Tashkent',
  'Asia/Tbilisi',
  'Asia/Tehran',
  'Asia/Thimphu',
  'Asia/Tokyo',
  'Asia/Tomsk',
  'Asia/Ulaanbaatar',
  'Asia/Urumqi',
  'Asia/Ust-Nera',
  'Asia/Vladivostok',
  'Asia/Yakutsk',
  'Asia/Yangon',
  'Asia/Yekaterinburg',
  'Asia/Yerevan',
  'Atlantic/Azores',
  'Atlantic/Bermuda',
  'Atlantic/Canary',
  'Atlantic/Cape_Verde',
  'Atlantic/Faroe',
  'Atlantic/Madeira',
  'Atlantic/Reykjavik',
  'Atlantic/South_Georgia',
  'Atlantic/Stanley',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Broken_Hill',
  'Australia/Currie',
  'Australia/Darwin',
  'Australia/Eucla',
  'Australia/Hobart',
  'Australia/Lindeman',
  'Australia/Lord_Howe',
  'Australia/Melbourne',
  'Australia/Perth',
  'Australia/Sydney',
  'Europe/Amsterdam',
  'Europe/Andorra',
  'Europe/Astrakhan',
  'Europe/Athens',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Brussels',
  'Europe/Bucharest',
  'Europe/Budapest',
  'Europe/Chisinau',
  'Europe/Copenhagen',
  'Europe/Dublin',
  'Europe/Gibraltar',
  'Europe/Helsinki',
  'Europe/Istanbul',
  'Europe/Kaliningrad',
  'Europe/Kiev',
  'Europe/Kirov',
  'Europe/Lisbon',
  'Europe/London',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Minsk',
  'Europe/Monaco',
  'Europe/Moscow',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Prague',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/Samara',
  'Europe/Saratov',
  'Europe/Simferopol',
  'Europe/Sofia',
  'Europe/Stockholm',
  'Europe/Tallinn',
  'Europe/Tirane',
  'Europe/Ulyanovsk',
  'Europe/Uzhgorod',
  'Europe/Vienna',
  'Europe/Vilnius',
  'Europe/Volgograd',
  'Europe/Warsaw',
  'Europe/Zaporozhye',
  'Europe/Zurich',
  'Indian/Chagos',
  'Indian/Christmas',
  'Indian/Cocos',
  'Indian/Kerguelen',
  'Indian/Mahe',
  'Indian/Maldives',
  'Indian/Mauritius',
  'Indian/Reunion',
  'Pacific/Apia',
  'Pacific/Auckland',
  'Pacific/Bougainville',
  'Pacific/Chatham',
  'Pacific/Chuuk',
  'Pacific/Easter',
  'Pacific/Efate',
  'Pacific/Enderbury',
  'Pacific/Fakaofo',
  'Pacific/Fiji',
  'Pacific/Funafuti',
  'Pacific/Galapagos',
  'Pacific/Gambier',
  'Pacific/Guadalcanal',
  'Pacific/Guam',
  'Pacific/Honolulu',
  'Pacific/Kiritimati',
  'Pacific/Kosrae',
  'Pacific/Kwajalein',
  'Pacific/Majuro',
  'Pacific/Marquesas',
  'Pacific/Nauru',
  'Pacific/Niue',
  'Pacific/Norfolk',
  'Pacific/Noumea',
  'Pacific/Pago_Pago',
  'Pacific/Palau',
  'Pacific/Pitcairn',
  'Pacific/Pohnpei',
  'Pacific/Port_Moresby',
  'Pacific/Rarotonga',
  'Pacific/Tahiti',
  'Pacific/Tarawa',
  'Pacific/Tongatapu',
  'Pacific/Wake',
  'Pacific/Wallis',
];

const getValidSupportedDateTimeFormats = (formats: string[]): string[] => {
  const supportedDateTimeFormats = [];
  for (let i = 0; i < formats.length; i++) {
    for (let j = 0; j < timeFormats.length; j++) {
      supportedDateTimeFormats.push(`${formats[i]} ${timeFormats[j]}`);
    }
  }
  return supportedDateTimeFormats;
};

const validDateTimeFormats = getValidSupportedDateTimeFormats(allDateFormats);

export const dateFormatOptions = allDateFormats.map((option) => ({
  label: option,
  value: option,
}));

export const dateTimeFormatOptions = validDateTimeFormats.map((option) => ({
  label: option,
  value: option,
}));

export const isDateFormatValid = (dateFormat: string): boolean => {
  return allDateFormats.includes(dateFormat);
};

export const isDateTimeFormatValid = (dateTimeFormat: string): boolean => {
  return validDateTimeFormats.includes(dateTimeFormat);
};

export const timeZoneOptions = timeZones.map((option: string) => ({
  label: option,
  value: option,
}));

export const userTzOffsetDiff = (userTimeZone: string) => {
  const userTzOffset =
    getTimezoneOffset(userTimeZone, new Date()) / (60 * 1000);
  const currentTzOffset = new Date().getTimezoneOffset();
  return userTzOffset - -1 * currentTzOffset;
};

export const convertToUserTz = ({
  value,
  userTimeZone,
  platform,
  showTime,
  attr,
}: {
  value: string;
  userTimeZone: string;
  platform: Platform;
  showTime: boolean;
  attr: IoDatasourceAttributes | undefined;
}): string => {
  let newValue = value;
  if (isNotEmpty(newValue) && attr?.attributeType !== 'StringDateTime') {
    if (!showTime || attr?.attributeType === 'Date') {
      // for date only fields, we need to remove the time portion
      // newValue = newValue.substring(0, 10);
      // const currentTzOffset = new Date().getTimezoneOffset();
      // add the offset to the date to get the correct date in the user's timezone
      /* newValue = addMinutes(
        new Date(newValue),
        currentTzOffset + 720,
      ).toISOString(); */
    } else if (isNotEmpty(userTimeZone)) {
      const tzDiff = userTzOffsetDiff(userTimeZone);
      try {
        newValue = addMinutes(new Date(newValue), tzDiff).toISOString();
      } catch (e) {
        newValue = '';
        console.error(e);
        console.warn(
          'Error processing date value of type',
          typeof value,
          value,
        );
        platform.showError(
          `Invalid value type ${typeof value}. Must be an ISO date string.`,
        );
      }
    }
  }
  return newValue;
};

export const convertToUserTzDate = ({
  date,
  userTimeZone,
  platform,
  utc,
  showTime,
  attr,
}: {
  date: Date | null;
  userTimeZone: string;
  platform: Platform;
  utc?: boolean;
  showTime: boolean;
  attr: IoDatasourceAttributes | undefined;
}): Date | null => {
  let newDate: Date | null = date;
  if (newDate && isValid(newDate)) {
    if (attr?.attributeType !== 'StringDateTime') {
      if (!showTime || attr?.attributeType === 'Date') {
        // for date only fields, we need to remove the time portion
        // and get the ISO date portion
        // newDate = new Date(newDate.toISOString().substring(0, 10));
        // const currentTzOffset = new Date().getTimezoneOffset();
        // just adding the offset is not working with daylight savings time
        // so we need to add 720 (12 hours) minutes to the offset to get the correct time
        // newDate = addMinutes(newDate, currentTzOffset + 720);
      } else if (isNotEmpty(userTimeZone)) {
        const tzDiff = userTzOffsetDiff(userTimeZone);
        try {
          newDate = addMinutes(newDate, -1 * tzDiff);
        } catch (e) {
          newDate = null;
          console.error(e);
          console.warn(
            'Error processing date value of type',
            typeof newDate,
            newDate,
          );
          platform.showError(
            `Invalid value type ${typeof newDate}. Must be an ISO date string.`,
          );
        }
      }
    }
  }
  return newDate;
};

export const populateCurrentTimeIfEmpty = (
  date: Date,
  attr: IoDatasourceAttributes | undefined,
  showTime: boolean,
): void => {
  if (
    isValid(date) &&
    date.getHours() === 0 &&
    date.getMinutes() === 0 &&
    date.getSeconds() === 0 &&
    date.getMilliseconds() === 0
  ) {
    if (!showTime || attr?.attributeType === 'Date') {
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
    } else {
      const newDate = new Date();
      date.setHours(newDate.getHours());
      date.setMinutes(newDate.getMinutes());
      date.setSeconds(newDate.getSeconds());
      date.setMilliseconds(newDate.getMilliseconds());
    }
  }
};

export function formatSeconds(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds - hours * 3600) / 60);
  seconds = seconds - hours * 3600 - minutes * 60;
  return `${hours ? ` ${hours} hour${hours > 1 ? 's' : ''}` : ''}${
    minutes ? ` ${minutes} minute${minutes > 1 ? 's' : ''}` : ''
  }${seconds ? ` ${seconds} second${seconds > 1 ? 's' : ''}` : ''}`;
}

export function toUTC(date: Date) {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
    ),
  );
}
